import React, {useContext, useState, useEffect} from 'react';
import { useTheme, Typography, makeStyles, List, ListItem, ListSubheader, ListItemText } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Helpers from '../../global/helpers';

import globalContext from '../../../context/global-context';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'block',
        width: '100%',
        maxHeight: 160,
        overflowY: 'auto'
    },
    inner: {},
}));

const AppUserRecentDevices = props => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const context = useContext(globalContext);

    const {id_user} = props;

    const headCells = ["transaction_date", "id_transaction", "amount", "type"]
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadData = async search => {
        setLoading(true);
        setError(null);
        setData([]);

        try {
            
            const res = await context.apiRequest(`/service_consumer/app_user/recent_devices?id=${id_user}`, 'GET');
            if(res.success)
                setData(res.result);
            else
                throw res.msg;
            
        } catch (err) {

            setError(typeof err === 'string' ? err : typeof err.msg !== 'undefined' ? err.msg : JSON.stringify(err));
            setData([]);
            
        } finally {
            setLoading(false);
        }
        
    }

    useEffect(() => {
        loadData();
    }, [])

    return (
        <React.Fragment>
            <div className={classes.container}>
                <div className={classes.inner}>

                    {error && <Alert severity="error">{error}</Alert>}

                    <List dense={true}>
                        {data.map((d, idx) => (
                            <ListItem key={idx}>
                                <ListItemText primary={`${Helpers.isNull(d.make)} ${Helpers.isNull(d.model)} (${Helpers.isNull(d.OS)}) `} secondary={`Last: ${Helpers.toLocaleDateTime(d.last_updated)}, App (${Helpers.isNull(d.app_version)})`} />
                            </ListItem>
                        ))}
                    </List>

                </div>
            </div>
        </React.Fragment>
    )
}
export default AppUserRecentDevices;